module.exports = __webpack_public_path__ + "img/memoji_avatar.171f2cfd.png";